/** Copyright (c) 2017 T. Rowe Price. All rights reserved. */

import { debounce } from 'lodash';

let componentsToNotifyOnWindowResize = [];
let windowResizeRegistered = false;

export function registerRenderOnWindowResize(component) {
  if (!windowResizeRegistered) {
    window.addEventListener('resize', windowResizeHandler, true);
    windowResizeRegistered = true;
  }

  componentsToNotifyOnWindowResize.push(component);
}

export function unregisterRenderOnWindowResize(component) {
  componentsToNotifyOnWindowResize = componentsToNotifyOnWindowResize.filter(
    (registered) => registered !== component
  );

  if (componentsToNotifyOnWindowResize.length === 0) {
    window.removeEventListener('resize', windowResizeHandler);
    windowResizeRegistered = false;
  }
}

const windowResizeHandler = debounce(function windowResizeHandler() {
  componentsToNotifyOnWindowResize.forEach((component) =>
    component.setState({
      windowInnerSize: {
        width: window.innerWidth,
        height: window.innerHeight
      }
    })
  );
}, 250);
